import type { AxiosResponse } from 'axios';

import api from '../axios';
import type {
  propsApiBatchPayment,
  propsApiPayment,
  propsRequestCreateBatchPaymentBody,
  propsRequestCreatePaymentBody,
} from '../interfaces';

export function createPaymentRequest(
  contractId: string,
  installmentId: string,
  body: propsRequestCreatePaymentBody,
  idempotencyKey?: string,
): Promise<AxiosResponse<propsApiPayment>> {
  return api.post(
    `/v1/contracts/${contractId}/installments/${installmentId}/payments`,
    body,
    {
      headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
    },
  );
}

export function createBatchPaymentRequest(
  contractId: string,
  body: propsRequestCreateBatchPaymentBody,
  idempotencyKey?: string,
): Promise<AxiosResponse<propsApiBatchPayment>> {
  return api.post(`/v1/contracts/${contractId}/payments/batch`, body, {
    headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
  });
}

export function reversePaymentRequest(
  contractId: string,
  installmentId: string,
  paymentId: string,
) {
  return api.delete(
    `/v1/contracts/${contractId}/installments/${installmentId}/payments/${paymentId}`,
  );
}
